/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import i18n from "data/lang/i18n";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import { NavLink } from "react-router-dom";
import Config from "data/config";
// import { Logger } from "cms/utils/log/logger";

export const columnsPlacementConfig = [
    {
        field: "content_title",
        headerName: i18n.t("commons.title"),
        cellClassName: "columnTitle",
        width: 250,
        renderCell: (params) => (
            <NavLink to={`/composer/${params?.row?.content_webpage}`} className='columnLink'>
                {params?.row?.content_title}
            </NavLink>
        ),
    },
    {
        field: "content_path",
        width: 350,
        headerName: i18n.t("commons.location"),
        cellClassName: "placementGrey",
    },
];


export const exportPlacementRows = (data, page) => {
    const rows = [];
    // Logger.debug(data);
    if (data) {
        for (const dataRow of data) {
            let row = { id: uuidv4() };

            Object.keys(dataRow)
                .filter((item) => item !== "id")
                .forEach((item) => {
                    row = {
                        ...row,
                        [`content_${item}`]: dataRow[item],
                    };

                    if (page === "forms") {
                        row = {
                            ...row,
                            content_reuses: dataRow?.reuse_count || 0,
                            content_responses: dataRow?.response_count || 0,
                        };
                    }
                });

            rows.push(row);
        }
    }
    return rows;
};

export const pageDefaults = {
    page: 1,  // NOT zero
    pageSize: 1000,
};

export const dataGridProps = {
    rowsPerPageOptions: [10, 20, 50, 100],
    rowHeight: 56,
    autoHeight: true,
    // filterMode: "server",
    // paginationMode: "server",
    // sortingMode: "server",
};

export const dataDuplicateGridProps = {
    rowsPerPageOptions: [8, 16, 32],
    rowHeight: 32,
    pageSize: 8,
    disableMultipleRowSelection: true,
    autoHeight: true,
    // filterMode: "server",
    // paginationMode: "server",
    // sortingMode: "server",
};

export const columnsDuplicateConfig = [
    {
        field: "content_name",
        headerName: i18n.t("commons.title"),
        cellClassName: "columnTitle",
        width: 350,
    },
    {
        field: "content_type",
        headerName: i18n.t("commons.type"),
        cellClassName: "columnType",
    },
    {
        field: "content_updated_at",
        headerName: i18n.t("commons.lastUpdated"),
        type: "dateTime",
        width: 150,
        renderCell: (params) => (
            <span>
                {params?.row?.content_updated_at
                    ? dayjs.utc(params?.row?.content_updated_at).local().format(Config.dates.general_short)
                    : "---"}
            </span>
        ),
    },
    {
        field: "content_uses",
        headerName: i18n.t("commons.uses"),
        renderCell: (params) => <span>{params?.row?.content_reuses ? params?.row?.content_reuses.length : 0}</span>,
    },
];

const formResponseStatusLabel = {
    "submitted": "Submitted",
    "in-progress": "In progress",
};

export const columnsResultsConfig = [
    {
        // Name
        field: "content_created_by",
        headerName: i18n.t("commons.name"),
        cellClassName: "columnTitle",
        width: 250,
        flex: 1
    },
    {
        // Email
        field: "content_email",
        headerName: i18n.t("commons.email"),
        width: 200,
        flex: 1
    },
    {
        // Status
        field: "content_status",
        headerName: i18n.t("commons.status"),
        width: 200,
        flex: 1,
        valueFormatter: ({ value }) => {
            if (!value) { 
                return "N/A";                          // no value → N/A
            }
            return formResponseStatusLabel[value] || "N/A";       // map or fallback
        }
    },
    {
        // Response Date
        field: "content_created_at",
        headerName: i18n.t("commons.responseDate"),
        type: "date",
        /**
         * Formats a date string
         * @param {object} params
         * @param {string} params.value
         */
        valueFormatter ({ value }) {
            const date = dayjs.utc(value);
            const isValid = date.isValid();

            if (!isValid) {
                return "---";
            }

            const formattedValue = date.local().format(Config.dates.general_long);
            return formattedValue;
        },
        width: 250,
        flex: 1
    },
];
